import React from 'react'
import createReactClass from 'create-react-class'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'
import TableForm from 'live/components/forms/ui/table-form'
import { encryptDidMount, handleEncryptSubmit } from 'live/components/forms/ui/UserTable/utils'
import EncryptForm from 'live/components/forms/ui/UserTable/EncryptForm'
import PasswordInput from 'live/components/forms/ui/UserTable/PasswordInput'

var ValidationMixin = require('live/components/forms/mixins/validation-mixin')
var ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'liverig-sitop',
    active: true,
    config: {
        enableForInput: true,
        uri: '',
        username: '',
        password: '',
        event_type: '',
        lookup_numero_fiscais: '',
        search_interval: 5,
        rigs: []
    },
    fullQualifier: null,
    qualifier: '',
    status: {}
})
var FormBase = require('live/components/extensions/ui/form')

const rigsConfig = [
    {
        get label() {
            return i18n('Name')
        },
        name: 'name',
        type: 'text'
    },
    {
        get label() {
            return i18n('SITOP code')
        },
        name: 'code',
        type: 'text'
    },
    {
        get label() {
            return i18n('Update rig state')
        },
        name: 'auto_state',
        type: 'toggle'
    }
]

// eslint-disable-next-line react/display-name
module.exports = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    uri: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('URI') + ' ' + i18n('must not be empty')
                    },
                    event_type: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Event type') + ' ' + i18n('must not be empty')
                    }
                }
            }
        }
    },
    _onSuccess: function() {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function() {
        window.location.href = '#/integrations/'
    },

    onChangeRigs(data) {
        const { object } = this.state
        const config = object.config

        config.rigs = data
        this.applyObj({ config: config })
    },

    onChangeInfo(data, key) {
        const { object } = this.state
        const config = object.config

        config[key] = data
        this.applyObj({ config: config })
    },
    componentDidMount() {
        encryptDidMount.bind(this)()
    },

    render: function() {
        const object = this.state.object
        const config = object.config
        const rigs = config.rigs || []

        const uiCfg = {
            hideDivider: true
        }
        handleEncryptSubmit.bind(this)()

        return (
            <EncryptForm self={this} uiCfg={uiCfg}>
                <div className="sitop">
                    <div className="form-area">
                        <div className="row">
                            <div className="col-md-12">
                                <FormGroup
                                    type="text"
                                    label={i18n('URI')}
                                    name="config.uri"
                                    value={config.uri}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.uri')}
                                    hasFeedback
                                    help={this.errorsFor('config.uri')}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormGroup
                                    type="text"
                                    label={i18n('Username')}
                                    name="config.username"
                                    value={config.username}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.username')}
                                    hasFeedback
                                    help={this.errorsFor('config.username')}
                                />
                            </div>
                            <div className="col-md-6">
                                <PasswordInput
                                    label={i18n('Password')}
                                    name="config.password"
                                    id={`${object?.type}/${object?.qualifier || ''}`}
                                    initPassword={this.state.original?.config?.password}
                                    onChange={newPassword => {
                                        this.handleValidation({
                                            target: {
                                                name: 'config.password',
                                                value: newPassword
                                            }
                                        })
                                    }}
                                    validationState={this.validationState('config.password')}
                                    hasFeedback
                                    setEditing={this.state.setHasUnSavedPassword}
                                    help={this.errorsFor('config.password')}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormGroup
                                    type="text"
                                    label={i18n('Event type')}
                                    name="config.event_type"
                                    value={config.event_type}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.event_type')}
                                    hasFeedback
                                    help={this.errorsFor('config.event_type')}
                                />
                            </div>
                            <div className="col-md-6">
                                <FormGroup
                                    type="text"
                                    label={i18n('Lookup table for expected inspector count')}
                                    name="config.lookup_numero_fiscais"
                                    value={config.lookup_numero_fiscais}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.lookup_numero_fiscais')}
                                    hasFeedback
                                    help={this.errorsFor('config.lookup_numero_fiscais')}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormGroup
                                    type="text"
                                    label={i18n('Search Interval')}
                                    name="config.search_interval"
                                    value={config.search_interval}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.search_interval')}
                                    hasFeedback
                                    help={this.errorsFor('config.search_interval')}
                                />
                            </div>
                        </div>
                    </div>

                    <h3 className="pos-form">{i18n('Rigs')}</h3>

                    <TableForm visibleRows={1} fields={rigsConfig} data={rigs} onChange={this.onChangeRigs} />
                </div>
            </EncryptForm>
        )
    }
})
